import { render, staticRenderFns } from "./InformacionPedido.vue?vue&type=template&id=e802afec&"
import script from "./InformacionPedido.vue?vue&type=script&lang=js&"
export * from "./InformacionPedido.vue?vue&type=script&lang=js&"
import style0 from "./InformacionPedido.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports